import { ForenkletEllerDetaljertEnum } from "../reportEnums";
import { IBygningsfysikkPremissRapport } from "../reportSchemas/bygningsfysikk/bygningsfysikkPremissrapport/bygningsfysikkPremissrapportSchema";

export const BYGNINGSFYSIKK_INIT_DATA: IBygningsfysikkPremissRapport = {
  generellInfo: {
    oppdragsnavn: "",
    emne: "",
    oppdragsgiver: "",
    kontaktperson: "",
    dokumentkode: "",
    tilgjengelighet: "",
    oppdragsleder: "",
    utarbeidetAv: "",
    ansvarligEnhet: "",
    koordinater: {
      ost: null,
      nord: null,
      sone: null,
    },
    eiendomsInformasjon: {
      gnr: null,
      bnr: null,
      snr: null,
      kommune: "",
    },
  },
  kapitler: {
    innledning: {
      // 1
      isActive: true,
      tekst: "1: Innledning",
      formelleForhold: {
        // 1.1
        isActive: true,
        tekst: "1.1: Formelle forhold",
      },
    },
    myndighetskrav: {
      // 2
      isActive: true,
      tekst: "2: Myndighetskrav, prosjektkrav og grensesnitt",
      forskrifter: {
        // 2.1
        isActive: true,
        tekst: "2.1: Forskrifter",
      },
      prosjektspesifikkeKrav: {
        // 2.2
        isActive: true,
        tekst: "2.2: Prosjektspesifikke krav ut over forskriftskrav",
      },
      uavhengigKontroll: {
        // 2.3
        isActive: true,
        tekst: "2.3: Uavhengig kontroll",
        tiltaksklasseEn: {
          // 2.3.1
          isActive: false,
          tekst: "2.3.1: Tiltaksklasse 1",
        },
        tiltaksklasseToEllerTre: {
          // 2.3.2
          isActive: true,
          tekst: "2.3.2: Tiltaksklasse 2 eller 3",
        },
      },
      grensesnitt: {
        // 2.4
        isActive: true,
        tekst: "2.4: Grensesnitt",
      },
    },
    detaljkontroll: {
      // 3
      isActive: true,
      tekst: "3: Detaljkontroll",
      prosjektspesifikkeDetaljsnitt: {
        // 3.1
        isActive: true,
        tekst: "3.1: Prosjektspesifikke detaljsnitt som krever ekstra fokus",
      },
    },
    omProsjektet: {
      // 4
      isActive: true,
      tekst: "4: Om prosjektet",
      bygget: {
        // 4.1
        isActive: true,
        tekst: "4.1: Bygget",
      },
      klima: {
        // 4.2
        isActive: true,
        tekst: "4.2: Klima",
        klimatilpasning: {
          // 4.2.1
          isActive: true,
          tekst: "4.2.1: Klimatilpasning",
        },
        uteklima: {
          // 4.2.2
          isActive: true,
          tekst: "4.2.2: Uteklima",
        },
        innvendigKlima: {
          // 4.2.3
          isActive: true,
          tekst: "4.2.3: Innvendig klima",
          forenkletEllerDetaljert: ForenkletEllerDetaljertEnum.FORENKLET,
        },
      },
    },
    byggfukt: {
      // 5
      isActive: true,
      tekst: "5: Byggfukt",
    },
    bygningsmessigEnergi: {
      // 6
      isActive: true,
      tekst: "6: Bygningsmessig energi",
      lufttetthet: {
        // 6.1
        isActive: true,
        tekst: "6.1: Lufttetthet",
        inputValue: null,
        forenkletEllerDetaljert: ForenkletEllerDetaljertEnum.FORENKLET,
      },
      kuldebroer: {
        // 6.2
        isActive: true,
        tekst: "6.2: Kuldebroer",
        inputValue: null,
        prosjektspesifikkeKuldebroer: {
          // 6.2.1
          isActive: true,
          tekst: "6.2.1: Prosjektspesifikke kuldebroer for nærmere vurdering",
        },
      },
    },
    radon: {
      // 7
      isActive: false,
      tekst: "7: Radon",
      radonsperre: {
        // 7.1
        isActive: false,
        tekst: "7.1: Radonsperre",
        underpunkter: {
          A: { isActive: false, tekst: "Bruksgruppe A" },
          B: {
            isActive: false,
            tekst: "Bruksgruppe B",
            rettUnderPastoep: {
              isActive: false,
              tekst: "Rett under påstøp",
            },
            radonsperreMedIsoOver: {
              isActive: false,
              tekst: "Radonsperre i isolasjonssjiktet",
            },
          },
          C: { isActive: false, tekst: "Bruksgruppe C" },
        },
        gjennomforinger: {
          // 7.1.1
          isActive: false,
          tekst: "7.1.1: Gjennomføringer",
        },
      },
      radonbronner: {
        // 7.2
        isActive: false,
        tekst: "7.2: Radonbrønner",
        horisontaleRadonbronner: {
          // 7.2.1
          isActive: false,
          tekst: "7.2.1: Horisontale radonbrønner i drenerende sjikt",
        },
      },
    },
    konstruksjonerMotTerreng: {
      // 8
      isActive: false,
      tekst: "8: Konstruksjoner mot terreng",
      gulvPaGrunn: {
        // 8.1
        isActive: false,
        tekst: "8.1: Gulv på grunn",
      },
      ringmur: {
        // 8.2
        isActive: false,
        tekst: "8.2: Ringmur",
      },
      veggerMotTerreng: {
        // 8.3
        isActive: false,
        tekst: "8.3: Vegger mot terreng",
      },
    },
    gulvMotTemperertAreal: {
      // 9
      isActive: false,
      tekst: "9: Gulv mot temperert areal",
      isolasjonOver: {
        // 9.1
        isActive: false,
        tekst: "9.1: Isolasjon over bærende dekke",
      },
      isolasjonUnder: {
        // 9.2
        isActive: false,
        tekst: "9.2: Isolasjon under bærende dekke",
      },
    },
    gulvMotFriluft: {
      // 10
      isActive: false,
      tekst: "10: Gulv mot friluft",
      betongMedUnderliggendeIsolasjon: {
        // 10.1
        isActive: false,
        tekst: "10.1: Betong med underliggende isolasjon",
        utenpaliggendeIsolasjon: {
          // 10.1.1
          isActive: false,
          tekst: "10.1.1: Utenpåliggende kontinuerlig isolasjon",
        },
        nedforetBindingsverk: {
          // 10.1.2
          isActive: false,
          tekst: "10.1.2: Nedforet bindingsverk",
        },
      },
      selvberendeStalplatetak: {
        // 10.2
        isActive: false,
        tekst: "10.2: Selvbærende stålplatetak (TRP)",
        overliggendeIsolasjon: {
          // 10.2.1
          isActive: false,
          tekst: "10.2.1: Overliggende isolasjon",
        },
        utenpaliggendeIsolasjon: {
          // 10.2.2
          isActive: false,
          tekst: "10.2.2: Utenpåliggende kontinuerlig isolasjon",
        },
        nedforetBindingsverk: {
          // 10.2.3
          isActive: false,
          tekst: "10.2.3: Nedforet bindingsverk",
        },
      },
      massivtre: {
        // 10.3
        isActive: false,
        tekst: "10.3: Massivtre",
        overliggendeIsolasjon: {
          // 10.3.1
          isActive: false,
          tekst: "10.3.1: Overliggende isolasjon",
        },
        utenpaliggendeIsolasjon: {
          // 10.3.2
          isActive: false,
          tekst: "10.3.2: Utenpåliggende kontinuerlig isolasjon",
        },
        nedforetBindingsverk: {
          // 10.3.3
          isActive: false,
          tekst: "10.3.3: Nedforet bindingsverk",
        },
      },
    },
    ytterveggerOverTerreng: {
      // 11
      isActive: false,
      tekst: "11: Yttervegger over terreng",
      bindingsverkMedLuftetKledning: {
        // 11.1
        isActive: false,
        tekst: "11.1: Bindingsverk med luftet/drenert kledning",
        staendeOgLiggendeTrekledning: {
          // 11.1.1
          isActive: false,
          tekst: "11.1.1: Stående og liggende trekledning",
        },
        platekledning: {
          // 11.1.2
          isActive: false,
          tekst: "11.1.2: Platekledning",
        },
        ventilertePussplater: {
          // 11.1.3
          isActive: false,
          tekst: "11.1.3: Ventilerte pussplater",
        },
        teglforblending: {
          // 11.1.4
          isActive: false,
          tekst: "11.1.4: Teglforblending",
        },
      },
      massivtreElementer: {
        // 11.2
        isActive: false,
        tekst: "11.2: Massivtre elementer",
        utenpaliggendeIsolasjon: {
          // 11.2.1
          isActive: false,
          tekst: "11.2.1: Utenpåliggende kontinuerlig isolasjon",
          staendeOgLiggendeTrekledning: {
            // 11.2.1.1
            isActive: false,
            tekst: "11.2.1.1: Stående og liggende trekledning",
          },
          platekledning: {
            // 11.2.1.2
            isActive: false,
            tekst: "11.2.1.2: Platekledning",
          },
          ventilertePussplater: {
            // 11.2.1.3
            isActive: false,
            tekst: "11.2.1.3: Ventilerte pussplater",
          },
          teglforblending: {
            // 11.2.1.4
            isActive: false,
            tekst: "11.2.1.4: Teglforblending",
          },
        },
        paforetBindingsverk: {
          // 11.2.2
          isActive: false,
          tekst: "11.2.2: Påforet bindingsverk",
          staendeOgLiggendeTrekledning: {
            // 11.2.2.1
            isActive: false,
            tekst: "11.2.2.1: Stående og liggende trekledning",
          },
          platekledning: {
            // 11.2.2.2
            isActive: false,
            tekst: "11.2.2.2: Platekledning",
          },
          ventilertePussplater: {
            // 11.2.2.3
            isActive: false,
            tekst: "11.2.2.3: Ventilerte pussplater",
          },
          teglforblending: {
            // 11.2.2.4
            isActive: false,
            tekst: "11.2.2.4: Teglforblending",
          },
        },
      },
      utvendigIsolertBetongvegg: {
        // 11.3
        isActive: false,
        tekst: "11.3: Utvendig isolert betongvegg",
        utenpaliggendeIsolasjon: {
          // 11.3.1
          isActive: false,
          tekst: "11.3.1: Utenpåliggende kontinuerlig isolasjon",
          staendeOgLiggendeTrekledning: {
            // 11.3.1.1
            isActive: false,
            tekst: "11.3.1.1: Stående og liggende trekledning",
          },
          platekledning: {
            // 11.3.1.2
            isActive: false,
            tekst: "11.3.1.2: Platekledning",
          },
          ventilertePussplater: {
            // 11.3.1.3
            isActive: false,
            tekst: "11.3.1.3: Ventilerte pussplater",
          },
          teglforblending: {
            // 11.3.1.4
            isActive: false,
            tekst: "11.3.1.4: Teglforblending",
          },
        },
        paforetBindingsverk: {
          // 11.3.2
          isActive: false,
          tekst: "11.3.2: Påforet bindingsverk",
          staendeOgLiggendeTrekledning: {
            // 11.3.2.1
            isActive: false,
            tekst: "11.3.2.1: Stående og liggende trekledning",
          },
          platekledning: {
            // 11.3.2.2
            isActive: false,
            tekst: "11.3.2.2: Platekledning",
          },
          ventilertePussplater: {
            // 11.3.2.3
            isActive: false,
            tekst: "11.3.2.3: Ventilerte pussplater",
          },
          teglforblending: {
            // 11.3.2.4
            isActive: false,
            tekst: "11.3.2.4: Teglforblending",
          },
        },
      },
      veggAvMur: {
        // 11.4
        isActive: false,
        tekst: "11.4: Vegg av mur/betong med puss på isolasjon",
      },
      prefabrikkerteVeggelementer: {
        // 11.5
        isActive: false,
        tekst: "11.5: Prefabrikkerte veggelementer",
        letteSandwichElementer: {
          // 11.5.1
          isActive: false,
          tekst: "11.5.1: Lette sandwichelementer",
          stalsandwich: {
            // 11.5.1.1
            isActive: false,
            tekst: "11.5.1.1: Stålsandwich",
          },
          bindingsverk: {
            // 11.5.1.2
            isActive: false,
            tekst: "11.5.1.2: Prefabrikkerte ytterveggelement i bindingsverk",
          },
        },
        tungeSandwichElementer: {
          // 11.5.2
          isActive: false,
          tekst: "11.5.2: Tunge sandwichelementer",
          betongsandwich: {
            // 11.5.2.1
            isActive: false,
            tekst: "11.5.2.1: Prefabrikkert betongsandwich",
          },
          lettklinker: {
            // 11.5.2.2
            isActive: false,
            tekst: "11.5.2.2: Sandwichelementer av lettklinkerelement",
          },
        },
      },
      murverk: {
        // 11.6
        isActive: false,
        tekst: "11.6: Murverk",
      },
      pahengsvegger: {
        // 11.7
        isActive: false,
        tekst: "11.7: Påhengsvegger (Curtain walls)",
      },
    },
    vinduerGlassfasaderYtterdorer: {
      // 12
      isActive: false,
      tekst: "12: Vinduer, glassfasader og ytterdører",
      generelleForinger: {
        // 12.1
        isActive: false,
        tekst: "12.1: Generelle føringer som gjelder vinduer, glassfasader og ytterdører",
        vinduer: {
          // 12.1.1
          isActive: false,
          tekst: "12.1.1: Vinduer",
        },
        glassfasader: {
          // 12.1.2
          isActive: false,
          tekst: "12.1.2: Glassfasader",
        },
        ytterdorer: {
          // 12.1.3
          isActive: false,
          tekst: "12.1.3: Ytterdører",
        },
      },
      terskellosninger: {
        // 12.2
        isActive: false,
        tekst: "12.2: Terskelløsninger for vinduer, glassfasader og ytterdører mot terreng",
      },
    },
    tak: {
      // 13
      isActive: false,
      tekst: "13: Tak",
      kompakteTak: {
        // 13.1
        isActive: false,
        tekst: "13.1: Kompakte tak",
        rettvendteTak: {
          // 13.1.1
          isActive: false,
          tekst: "13.1.1: Rettvendte tak",
          plantUnderlag: {
            // 13.1.1.1
            isActive: false,
            tekst: "13.1.1.1: Plant underlag",
          },
          stalplateTak: {
            // 13.1.1.2
            isActive: false,
            tekst: "13.1.1.2: Selvbærende stålplatetak (TRP)",
          },
        },
        omvendteTak: {
          // 13.1.2
          isActive: false,
          tekst: "13.1.2: Omvendte tak",
        },
        duotak: {
          // 13.1.3
          isActive: false,
          tekst: "13.1.3: Duotak",
        },
        gronneTak: {
          // 13.1.4
          isActive: false,
          tekst: "13.1.4: Grønne tak",
          sedumtak: {
            // 13.1.4.1
            isActive: false,
            tekst: "13.1.4.1: Sedumtak",
          },
          lettBeplantning: {
            // 13.1.4.2
            isActive: false,
            tekst: "13.1.4.2: Tak med lett beplantning",
          },
          tungBeplantning: {
            // 13.1.4.3
            isActive: false,
            tekst: "13.1.4.3: Tak med tung beplantning",
          },
        },
        blaTak: {
          // 13.1.5
          isActive: false,
          tekst: "13.1.5: Blå tak",
        },
      },
      elementTak: {
        // 13.2
        isActive: false,
        tekst: "13.2: Element tak",
      },
      skraLuftedeTretak: {
        // 13.3
        isActive: false,
        tekst: "13.3: Skrå luftede tretak",
        takflateOppvarmetAreal: {
          // 13.3.1
          isActive: false,
          tekst: "13.3.1: Takflate mot oppvarmet areal",
        },
        kaldeLoft: {
          // 13.3.2
          isActive: false,
          tekst: "13.3.2: Kalde loft",
        },
      },
      glasstak: {
        // 13.4
        isActive: false,
        tekst: "13.4: Glasstak",
      },
      solcellerPaTak: {
        // 13.5
        isActive: false,
        tekst: "13.5: Solceller på tak",
      },
      takterrasser: {
        // 13.6
        isActive: false,
        tekst: "13.6: Takterrasser",
        lettTrafikkert: {
          // 13.6.1
          isActive: false,
          tekst: "13.6.1: Lett trafikkert",
        },
        tungtTrafikkert: {
          // 13.6.2
          isActive: false,
          tekst: "13.6.2: Tungt trafikkert",
        },
      },
    },
    spesielleRomOgKonstruksjoner: {
      // 14
      isActive: false,
      tekst: "14: Spesielle rom og konstruksjoner",
      vatrom: {
        // 14.1
        isActive: false,
        tekst: "14.1: Våtrom og rom med vanninstallasjoner",
      },
      nedkjolteRom: {
        // 14.2
        isActive: false,
        tekst: "14.2: Nedkjølte rom",
        kjolerom: {
          // 14.2.1
          isActive: false,
          tekst: "14.2.1: Kjølerom",
        },
        fryserom: {
          // 14.2.2
          isActive: false,
          tekst: "14.2.2: Fryserom",
        },
      },
      bygningerUnderGrunnvann: {
        // 14.3
        isActive: false,
        tekst: "14.3: Bygninger/rom under grunnvannstand",
      },
      trafoRom: {
        // 14.4
        isActive: false,
        tekst: "14.4: Traforom",
      },
      ventilasjonssjakter: {
        // 14.5
        isActive: false,
        tekst: "14.5: Ventilasjonssjakter og inntakskammer",
      },
      basseng: {
        // 14.6
        isActive: false,
        tekst: "14.6: Basseng",
      },
      badstue: {
        // 14.7
        isActive: false,
        tekst: "14.7: Badstue",
      },
      storkjokken: {
        // 14.8
        isActive: false,
        tekst: "14.8: Storkjøkken",
      },
      parkeringskjeller: {
        // 14.9
        isActive: false,
        tekst: "14.9: Parkeringskjeller",
      },
      karnapp: {
        // 14.10
        isActive: false,
        tekst: "14.10: Karnapp",
      },
      sportsgulv: {
        // 14.11
        isActive: false,
        tekst: "14.11: Sportsgulv",
      },
    },
  },
};
